import moment from "moment";

export const GAME_TITLE = process.env.REACT_APP_GAME_NAME!
const keysPrefix = GAME_TITLE.toLowerCase();
const gameStateKey = `${keysPrefix}_gameState`
const highContrastKey = `${keysPrefix}_highContrast`
const gameStatusKey = `${keysPrefix}_gameStatus`
const gameWonKey = `${keysPrefix}_gameWon`
const gameLostKey = `${keysPrefix}_gameLost`
const finalGameStatKey = `${keysPrefix}_finalGameStats`
const hurdleGameStatKey = `${keysPrefix}_hurdleGameStats`
const gameScoreKey = `${keysPrefix}_gameScore`
const gameStartedKey = `${keysPrefix}_gameStarted`
const gameFinishedKey = `${keysPrefix}_gameFinishedKey`
const finalWonKey = `${keysPrefix}_finalWon`
const scoreAdded = `${keysPrefix}_finalScore`
const hardModeKey =  `${keysPrefix}_gameMode`;
const solutionIndexKey =  `${keysPrefix}_solutionIndex`;


type StoredGameState = {
  guesses: string[]
  _solution: string
  currentStep: number
  date: string
}

export const saveFinalScoreToLocalStorage = (flag: boolean) => {
  try {

    localStorage.setItem(scoreAdded, JSON.stringify(flag));
  } catch(e) {

  }
  
}

export const getFinalScoreFromLocalStorage = () => {
  try {

    const state = localStorage.getItem(scoreAdded)
if (state) {
  return Boolean(state)
} else {
  return false;
}
} catch(e) {

}
}

export const saveGameFinishedToLocalStorage = (flag: boolean) => {
  try {

    localStorage.setItem(gameFinishedKey, JSON.stringify(flag));
  } catch(e) {

  }
  
}

export const saveFinalWonToLocalStorage = (flag: boolean) => {
  try {

    localStorage.setItem(finalWonKey, JSON.stringify(flag));
  } catch(e) {

  } 
}

export const loadFinalWonFromLocalStorage = () => {
  try {

      const state = localStorage.getItem(finalWonKey)
  if (state) {
    return Boolean(state)
  } else {
    return false;
  }
  } catch(e) {

  }
}

export const loadGameFinishedFromLocalStorage = () => {
  try {

      const state = localStorage.getItem(gameFinishedKey)
  if (state) {
    return Boolean(state)
  } else {
    return false;
  }
  } catch(e) {
    return false;
  }
}

export const saveGameStartedToLocalStorage = (flag: boolean) => {
  try {

    localStorage.setItem(gameStartedKey, JSON.stringify(flag));
  } catch(e) {

  }
  
}

export const loadGameStartedFromLocalStorage = () => {
  try {

      const state = localStorage.getItem(gameStartedKey)
  if (state) {
    return Boolean(state)
  } else {
    return false;
  }
  } catch(e) {
    return false;
  }

}


export const saveGameScoreToLocalStorage = (score: number) => {
  try {

    localStorage.setItem(gameScoreKey, JSON.stringify(score))
  } catch(e) {

  }
  
}

export const loadGameScoreFromLocalStorage = () => {
  try {

    const state = localStorage.getItem(gameScoreKey)
    if (state) {
      return Number(state)
    } else {
      return 0
    }
  } catch(e) {
    return 0;
  }
}


export const saveGameWonToLocalStorage = (flag: boolean) => {
  try {

    localStorage.setItem(gameWonKey, JSON.stringify(flag))
  } catch(e) {

  }
}

export const loadGameWonFromLocalStorage = () => {
  try {
      const state = localStorage.getItem(gameWonKey)
  return state || null
  } catch(e) {
    return null;
  }
}

export const saveGameLostToLocalStorage = (flag: boolean) => {
  try {

    localStorage.setItem(gameLostKey, JSON.stringify(flag))
  } catch(e) {

  }
  
}

export const loadGameLostFromLocalStorage = () => {
  try {

    const state = localStorage.getItem(gameLostKey)
    return state || null
  } catch(e) {
    return null;
  }
  
}

export const saveGameStateToLocalStorage = (gameState: StoredGameState) => {
  try {
    localStorage.setItem(gameStateKey, JSON.stringify(gameState))
  } catch(e) {}
  
}


export const loadGameStateFromLocalStorage = () => {
  try {
      const state = localStorage.getItem(gameStateKey)
  if (state) {
    const epochMs = new Date("January 1, 2022").valueOf()
    const msInDay = 86400000
    
    const today = new Date();  
    let now = today.getTime();
    if (moment().isDST()) {
      now = moment(now).add(1, "hour").valueOf();
    }
    let currentSolutionIndex = Math.floor((now - epochMs) / msInDay);
    let _state = (JSON.parse(state) as StoredGameState)
    if ((_state.date && !sameDay(new Date(_state.date), new Date())) || currentSolutionIndex.toString() !== getStoredHurdleIndex()) {
      localStorage.removeItem(gameStateKey)
      localStorage.removeItem(gameStatusKey)
      localStorage.removeItem(gameWonKey)
      localStorage.removeItem(gameLostKey)
      localStorage.removeItem(gameScoreKey)
      localStorage.removeItem(gameStartedKey)
      localStorage.removeItem(gameFinishedKey)
      localStorage.removeItem(finalWonKey)
      localStorage.removeItem(scoreAdded)
      localStorage.removeItem(solutionIndexKey)
    }
  }

  return state ? (JSON.parse(state) as StoredGameState) : null
  } catch(e) {
    return null;  
  }
}

export const saveGameStatusToLocalStorage = (gameStatus: string ) => {
  try {
    localStorage.setItem(gameStatusKey, gameStatus)
  } catch(e) {}
}


export const loadGameStatusFromLocalStorage = () => {
  try {
    const status = localStorage.getItem(gameStatusKey);
    return status ? status : ""
  } catch(e) {
    return "";
  }
}


function sameDay(d1: Date, d2: Date) {
  return new Date(d1).getFullYear() === d2.getFullYear() &&
  new Date(d1).getMonth() === d2.getMonth() &&
  new Date(d1).getDate() === d2.getDate();
}



export type GameStats = {
  winDistribution: number[]
  gamesFailed: number
  currentStreak: number
  bestStreak: number
  totalGames: number
  successRate: number
}

export type FinalGameStats = {
  winDistribution: number[]
  gamesFailed: number
  currentStreak: number
  bestStreak: number
  totalGames: number
  successRate: number
}


export const saveFinalStatsToLocalStorage = (gameStats: GameStats) => {
  try {

    localStorage.setItem(finalGameStatKey, JSON.stringify(gameStats))
  } catch(e) {}
  
}

export const saveHurdleStatsToLocalStorage = (gameStats: GameStats) => {
  try {

    localStorage.setItem(hurdleGameStatKey, JSON.stringify(gameStats))
  } catch(e) {}
}

export const loadFinalStatsFromLocalStorage = () => {
  try {
    const stats = localStorage.getItem(finalGameStatKey)
    return stats ? (JSON.parse(stats) as GameStats) : null
  } catch(e) {
    return null;
  }
}

export const loadHurdleStatsFromLocalStorage = () => {
  try {

    const stats = localStorage.getItem(hurdleGameStatKey)
    return stats ? (JSON.parse(stats) as GameStats) : null
  } catch(e) {
    return  null;
  }
  
}

export const setStoredIsHighContrastMode = (isHighContrast: boolean) => {
  try {

    if (isHighContrast) {

      localStorage.setItem(highContrastKey, '1')
     } else {
       localStorage.removeItem(highContrastKey)
     }
  } catch(e) {}

}

export const getStoredIsHighContrastMode = () => {
  try {
    const highContrast = localStorage.getItem(highContrastKey)
    return highContrast === '1'
  } catch(e) {
    return false;
  }
}


export const setStoredIsHardMode = (hardMode: string) => {
  try {
    localStorage.setItem(hardModeKey, hardMode)
  } catch(e) {
  }
}

export const getStoredIsHardMode = () => {
  try {
    if (localStorage.getItem(hardModeKey)) {
      return localStorage.getItem(hardModeKey) === 'hard'
    } else {
      return false;
    }
  } catch(e) {
    return false;
  }
}

export const setStoredHurdleIndex = (index: string) => {
  try {
    localStorage.setItem(solutionIndexKey, index)
  } catch(e) {
  }
}

export const getStoredHurdleIndex = () => {
  try {
    return localStorage.getItem(solutionIndexKey)
  } catch(e) {
    return "";
  }
}